import { travel } from 'api';
import { AxiosResponse } from 'axios';

import { VehicleDetailPayload, VehicleDetailResponse } from 'models/auto/vehicleDetail';
import { VehicleValidateResponse } from 'models/auto/vehicleValidate';
import { Response } from 'models/response';

export const getAutoDetails = async (
  payload: VehicleDetailPayload,
): Promise<AxiosResponse<Response<VehicleDetailResponse>>> => travel.post('Vehicle/Details', payload);

export const getAutoValidate = async (
  detailId: string,
  sessionToken: string,
  userId: string,
  distanceRestriction: string,
): Promise<AxiosResponse<Response<VehicleValidateResponse>>> =>
  travel.post('Vehicle/Validate', {
    sessionToken,
    DetailId: detailId,
    RateId: 1,
    IsPayNow: true,
    userId,
    distanceRestriction,
  });
